<template>
  <aside
    class="flex flex-col h-screen p-4 transition-all duration-200 ease-in-out transform bg-sidebar-green-primary shrink-0 no-scrollbar"
    :class="{ 'lg:w-64 lg:static lg:left-auto lg:top-auto lg:translate-x-0 lg:overflow-y-auto overflow-x-hidden': sideBarActive, 'w-16 md:w-20': !sideBarActive }"
  >
    <!-- Logo -->
    <div class="px-2 py-1 bg-white rounded-lg w-fit">
      <NuxtImg
        src="/zuno-logo.png"
        alt="Veridis Logo"
        class="w-8 h-auto"
      />
    </div>

    <!-- Menus -->
    <div class="space-y-2">
      <div class="mt-3">
        <!-- Zuno Engineer -->
        <ZunoEngineerMenu v-if="isZunoEngineer" />

        <!-- Super Admin -->
        <SuperAdminMenu v-else-if="isSuperUser" />

        <!-- User -->
        <div v-else>
          <UserMenuComponent />
        </div>
      </div>
    </div>

    <div
      class="h-0.5 mt-3 mb-5 w-full bg-gray-100/10"
      :class="{ hidden: !sideBarActive, block: sideBarActive }"
    />

    <div class="justify-end mt-auto">
      <div class="h-0.5 my-3 w-full bg-gray-100/10" />
      <div
        class="items-center justify-between hidden gap-x-3"
        :class="{ '!flex': !sideBarActive, 'lg:flex': sideBarActive }"
      >
        <div
          class="flex gap-4"
          :class="{ 'mb-0': sideBarActive }"
        >
          <a
            href="https://zunocarbon.atlassian.net/servicedesk/customer/portals"
            target="_blank"
            class="relative z-10 block text-white truncate transition duration-150 hover:text-[#FF8024]"
            title="Help Center"
          >
            <div
              class="flex items-center py-3 md:py-3 "
              :class="{ 'p-0 justify-center': !sideBarActive, 'md:px-3 md:py-3 lg:px-3': sideBarActive }"
            >
              <div
                class="flex items-center justify-betwwen menu-inner"
                :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
              >
                <QuestionMarkCircleLightSmall
                  class="w-6 h-6"
                  :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
                />
                <span
                  class="hidden text-sm font-medium duration-200 lg:sidebar-expanded:opacity-100 2xl:opacity-100"
                  :class="{ 'md:hidden lg:block': sideBarActive }"
                >Help Center</span>
              </div>
            </div>
          </a>
        </div>
        <button
          :class="{ '!block': !sideBarActive, 'm-0': sideBarActive }"
          @click="$store.sidebar.toggleSidebar()"
        >
          <MenuFold
            v-if="active"
            class="text-white truncate hover:text-[#FF8024]"
          />
          <MenuFold
            v-else
            class="text-white hover:text-[#FF8024] rotate-180"
          />
        </button>
      </div>
    </div>
  </aside>
</template>

<script setup>
import { debounce } from 'lodash'
import { useSidebarStore } from '~/store/sidebar'

const sidebarStore = useSidebarStore()

const isZunoEngineer = computed(() => {
  return useNuxtApp().$store.auth.authenticatedUser?.is_zuno_engineer
})

const isSuperUser = computed(() => {
  return useNuxtApp().$store.auth.authenticatedUser?.is_superuser
})

const active = computed(() => {
  return sidebarStore.isActive
})

const sideBarActive = computed(() => {
  return sidebarStore.responsiveActive
})

const handleResize = debounce(() => {
  sidebarStore.updateWindowWidth()
}, 250)

// resize listener
onMounted(() => {
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
  handleResize.cancel()
})
</script>
